import {
  ExtractionRangeEnum,
  type All,
  type Cell,
  type Column,
  type Custom,
  type Down,
  type First,
  type IFormValue,
  type IRule,
  type Keyword,
  type Last,
  type Left,
  type Negative,
  type Order,
  type Positive,
  type Right,
  type Row,
  type RowColumn,
  type Target,
  type Up,
} from './type';

export const ALL: All = 'ALL';
export const FIRST: First = 'FIRST';
export const LAST: Last = 'LAST';
export const TARGET: Target = 'TARGET';
export const KEYWORD: Keyword = 'KEYWORD';
export const ORDER: Order = 'ORDER';
export const ROW: Row = 'ROW';
export const COLUMN: Column = 'COLUMN';
export const CELL: Cell = 'CELL';
export const CUSTOM: Custom = 'CUSTOM';
export const ROW_COLUMN: RowColumn = 'ROW_COLUMN';
export const UP: Up = 'UP';
export const DOWN: Down = 'DOWN';
export const LEFT: Left = 'LEFT';
export const RIGHT: Right = 'RIGHT';
export const POSITIVE: Positive = 'POSITIVE';
export const NEGATIVE: Negative = 'NEGATIVE';

export const RANGE_OPTIONS = [
  {
    label: '全文',
    value: ALL,
  },
  {
    label: '首页',
    value: FIRST,
  },
  {
    label: '尾页',
    value: LAST,
  },
  {
    label: '指定页',
    value: TARGET,
  },
];

export const TABLE_MODE_OPTIONS = [
  {
    label: '关键词',
    value: KEYWORD,
  },
  {
    label: '表格顺序',
    value: ORDER,
  },
];

export const RULE_MODE_OPTIONS = [
  { label: '抽取行内容', value: ROW },
  { label: '抽取列内容', value: COLUMN },
  { label: '抽取单元格', value: CELL },
];

export const CELL_FILTER_OPTIONS = [
  { label: '关键词', value: KEYWORD },
  { label: '行列顺序', value: ROW_COLUMN },
];

export const INITIAL_RULE = {
  position_type: 'ROW',
  row_content_config: {
    row_config: {
      position_method: 'KEYWORD',
      offset_config: {
        direction: 'DOWN',
        offset: 0,
      },
    },
    colum_range_config: {
      range_type: 'ALL',
      begin: {
        position_method: 'KEYWORD',
        offset_config: {
          direction: 'RIGHT',
          offset: 0,
        },
      },
      end: {
        position_method: 'KEYWORD',
        offset_config: {
          direction: 'LEFT',
          offset: 0,
        },
      },
    },
  },
  col_content_config: {
    colum_config: {
      position_method: 'KEYWORD',
      offset_config: {
        direction: 'RIGHT',
        offset: 0,
      },
    },
    row_range_config: {
      range_type: 'ALL',
      begin: {
        position_method: 'KEYWORD',
        offset_config: {
          direction: 'DOWN',
          offset: 0,
        },
      },
      end: {
        position_method: 'KEYWORD',
        offset_config: {
          direction: 'UP',
          offset: 0,
        },
      },
    },
  },
  cell_content_config: {
    grid_position: 'KEYWORD',
    left_right_offset: {
      direction: 'RIGHT',
      offset: 0,
    },
    up_down_offset: {
      direction: 'DOWN',
      offset: 0,
    },
    row_config: {
      position_method: 'KEYWORD',
      offset_config: {
        direction: 'DOWN',
        offset: 0,
      },
      keyword: '行定位',
    },
    colum_config: {
      position_method: 'KEYWORD',
      offset_config: {
        direction: 'RIGHT',
        offset: 0,
      },
      keyword: '列定位',
    },
  },
} as IRule;
export const INITIAL_VALUES = {
  extraction_range: 'ALL',
  is_cross_page: false,
  table_order_type: 'KEYWORD',
  keywords: '',
  table_order: {
    direction: 'POSITIVE',
    offset: 1,
  },
  rules: [INITIAL_RULE],
} as Partial<IFormValue>;

/** 抽取范围 */
const ExtractionRangeMap: Record<keyof typeof ExtractionRangeEnum, string> = {
  [ExtractionRangeEnum.ALL]: '全文',
  [ExtractionRangeEnum.FIRST]: '首页',
  [ExtractionRangeEnum.LAST]: '末页',
  [ExtractionRangeEnum.TARGET]: '指定页',
} as const;

/** 抽取范围 */
export const extractionRangeOptions = Object.entries(ExtractionRangeEnum).map(
  ([key, value]) => ({
    label: ExtractionRangeMap[key as keyof typeof ExtractionRangeMap],
    value: value,
  }),
);
